/* eslint-disable no-nested-ternary */
import { media } from 'src/components/base';
import styled, { css } from 'styled-components';

import {
  Breakpoint,
  breakpointNames,
} from 'src/components/base/styles/variables';

// We need to cover ALL breakpoints here since we use '`${breakpoint}Only`'
// If we left out xxl for example, then >1600px would look very weird as it wouldn't be covered by any breakpoint
// (This only works because the smallest and largest breakpoints are open in their respective direction)
export const ITEMS: Record<Breakpoint, number> = {
  small: 2,
  medium: 3,
  large: 4,
  xlarge: 4,
  xxlarge: 4,
};

const GAPS: Record<Breakpoint, number> = {
  small: 0.5,
  medium: 1,
  large: 1,
  xlarge: 1,
  xxlarge: 1,
};

// These are calculated for each render
const SIZES = {} as Record<Breakpoint, string>;
const GUTTERS = {} as Record<Breakpoint, string>;

/**
 * Certain experiments require a different grid layout, which is passed as props
 * Here we determine how many items to show depending on the passed props
 */
function getItemsForExperiments({
  isWide,
  isExtraWide,
}: {
  isWide?: boolean;
  isExtraWide?: boolean;
}) {
  if (isExtraWide) {
    return {
      large: 4,
      xlarge: 5,
      xxlarge: 6,
    };
  }
  if (isWide) {
    return {
      large: 5,
      xlarge: 5,
      xxlarge: 5,
    };
  }
  return {
    large: 4,
    xlarge: 4,
    xxlarge: 4,
  };
}

export const OffersGrid = styled.ul<{
  isWide?: boolean;
  /**
   * Whether to show 5/6/7 items on lage/xlarge/xxlarge
   * Currently only used on KWLP
   */
  isExtraWide?: boolean;
}>(props => {
  // We need to mutate the object here because src/areas/product-collection/components/products/layout-grid/layout-grid.tsx relies on the current layout configuration, and that depends on getItemsForExperiment
  // We don't want to implement the same logic twice, therefore we need to access this object from somewhere else
  Object.assign(ITEMS, getItemsForExperiments(props));

  // I'm not really happy with the current solution, but if we dynamically change ITEMS.large etc. for each render, then we also need to recalculate (gutter) sizes for each render
  // eslint-disable-next-line no-restricted-syntax, guard-for-in
  for (const bp of breakpointNames) {
    SIZES[bp] = `${100 / ITEMS[bp]}%`;
    GUTTERS[bp] = `${GAPS[bp] * (ITEMS[bp] - 1)}rem / ${ITEMS[bp]}`;
  }

  return css`
    @supports (grid-template-columns: repeat(auto-fill, minmax(auto, 50%))) {
      display: grid;
      flex: 1 0 auto;
      list-style: none;

      ${/* This only works because smallOnly and xxlargeOnly have no boundaries in each unset direction i.e. everything larger than xxlarge is considered xxlarge */ null}
      ${breakpointNames.map(breakpoint => {
        return media[`${breakpoint}Only`]`
          grid-gap: ${GAPS[breakpoint]}rem;
          grid-template-columns: repeat(
            auto-fill,
            minmax(auto, calc(${SIZES[breakpoint]} - ${GUTTERS[breakpoint]}))
          );
        `;
      })}
    }

    /* Fallback to flex if grid-template-columns is not supported */
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  `;
});

export const OffersGridItem = styled.li``;
